
<div class="sm:block">
  <div :class="paddingClass">
    <div class="border-t border-gray-200"></div>
  </div>
</div>
